import { render, staticRenderFns } from "./Items.vue?vue&type=template&id=5116f1c8&scoped=true"
import script from "./Items.ts?vue&type=script&lang=ts&external"
export * from "./Items.ts?vue&type=script&lang=ts&external"
import style0 from "./Items.vue?vue&type=style&index=0&id=5116f1c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5116f1c8",
  null
  
)

export default component.exports